import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=480f9ad0&scoped=true&"
import script from "./Governance.vue?vue&type=script&lang=ts&"
export * from "./Governance.vue?vue&type=script&lang=ts&"
import style0 from "./Governance.vue?vue&type=style&index=0&id=480f9ad0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f9ad0",
  null
  
)

export default component.exports